/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Console_Copy_Api_KeyInputs */

const en_console_copy_api_key = /** @type {(inputs: Console_Copy_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy API key`)
};

const zh_hans1_console_copy_api_key = /** @type {(inputs: Console_Copy_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制 API 密钥`)
};

const pt_br2_console_copy_api_key = /** @type {(inputs: Console_Copy_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar chave de API`)
};

const es_console_copy_api_key = /** @type {(inputs: Console_Copy_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar clave de API`)
};

const fr_console_copy_api_key = /** @type {(inputs: Console_Copy_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier la clé API`)
};

const de_console_copy_api_key = /** @type {(inputs: Console_Copy_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel kopieren`)
};

const ru_console_copy_api_key = /** @type {(inputs: Console_Copy_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать API-ключ`)
};

const it_console_copy_api_key = /** @type {(inputs: Console_Copy_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia chiave API`)
};

/**
* | output |
* | --- |
* | "Copy API key" |
*
* @param {Console_Copy_Api_KeyInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const console_copy_api_key = /** @type {((inputs?: Console_Copy_Api_KeyInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Copy_Api_KeyInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_console_copy_api_key(inputs)
	if (locale === "pt-BR") return pt_br2_console_copy_api_key(inputs)
	if (locale === "es") return es_console_copy_api_key(inputs)
	if (locale === "fr") return fr_console_copy_api_key(inputs)
	if (locale === "de") return de_console_copy_api_key(inputs)
	if (locale === "ru") return ru_console_copy_api_key(inputs)
	if (locale === "it") return it_console_copy_api_key(inputs)
	return en_console_copy_api_key(inputs)
});